import {
  BMComponentsType,
  BMPrimitives,
  BMSkeletonLoader,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { Pressable, StyleSheet } from "react-native";
import BMView from "../../../components/View/BMView";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import BalanceWidget, { Props as BalaceWidgetProps } from "./BalanceWidget";

export type Props = {
  profile: {
    data: {
      companyName: string;
      employeeName: string;
      employeeRole: string | undefined;
    };
    isFetching: boolean;
    isError: boolean;
    refetch: () => void;
  };
  balance?: BalaceWidgetProps;
  onClickCompanyInfo?: () => void;
};

export default function NavigationProfileWidget({
  profile: {
    data: { companyName, employeeName, employeeRole },
    isFetching,
    isError,
    refetch,
  },
  balance,
  onClickCompanyInfo,
}: Props) {
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);
  const { CorporateNavigationProfileWidget: cr } = useMobileContentResource();

  return (
    <BMView style={styles.container} spacing="lg">
      <BMView spacing="sm" row>
        <BMView flex>
          <Pressable onPress={onClickCompanyInfo}>
            <BMView spacing="xs">
              <BMText
                variant="titleSmall"
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {companyName}
              </BMText>
              <BMText variant="uiSmallLi" ink="BMStyleTextInkAction">
                {cr.ctaCompanyInfo}
              </BMText>
            </BMView>
          </Pressable>
        </BMView>
        {balance && <BalanceWidget {...balance} />}
      </BMView>
      <BMView spacing="sm" row>
        <BMView flex spacing="xs">
          <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
            {cr.employeeNameLabel}
          </BMText>
          <BMText variant="uiNormal">{employeeName}</BMText>
        </BMView>
        <BMView flex spacing="xs">
          <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
            {cr.employeeRoleLabel}
          </BMText>
          {isFetching ? (
            <BMSkeletonLoader
              width={BMPrimitives.BMSize.xl6}
              height={BMPrimitives.BMSize.lg}
            />
          ) : null}
          {!isFetching && isError ? (
            <Pressable onPress={refetch}>
              <BMView row spacing="xs">
                <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
                  {cr.failedToFetchData}
                </BMText>
                <BMText variant="uiSmallLi" ink="BMStyleTextInkAction">
                  {cr.ctaTryAgain}
                </BMText>
              </BMView>
            </Pressable>
          ) : null}
          {!isFetching && !isError && (
            <BMText variant="uiNormal" numberOfLines={1} ellipsizeMode="tail">
              {cr.employeeRoleLabel}
            </BMText>
          )}
        </BMView>
      </BMView>
    </BMView>
  );
}

const createStyles = (BMComponents: BMComponentsType) => {
  return StyleSheet.create({
    container: {
      width: "100%",
      paddingVertical: BMPrimitives.BMSize.lg,
      paddingHorizontal: BMPrimitives.BMSize.md,
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
      borderBottomColor: BMComponents.BMStyleLineBordercolorSubtle,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolor,
    },
  });
};
